import {makeStyles, ThemeProvider} from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';

import {extendedTypography} from 'src/themes/themeNext/extendedTypography';
import {themeNext} from 'src/themes/themeNext';
import {CloseIcon} from 'src/componentsNext/icons/actions/CloseIcon';

const useStyles = makeStyles(theme => ({
  container: {
    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-start'
    }
  },
  containerXsCentered: {
    [theme.breakpoints.down('xs')]: {
      alignItems: 'center'
    }
  },
  paper: {
    borderRadius: 12,
    border: `1px solid ${theme.palette.colors.blue[500]}`,

    boxShadow: '0px 0px 32px 0px rgba(0, 0, 0, 0.80)',
    backgroundColor: theme.palette.colors.blue[700],

    boxSizing: 'content-box',

    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(12),
      margin: theme.spacing(2)
    }
  },
  paperFullWidth: {width: '100%'},
  paperWidthXs: {
    maxWidth: 328
  },
  paperWidthSm: {
    maxWidth: 372
  },
  paperWidthMd: {
    maxWidth: 480
  },

  paperWidthLg: {
    maxWidth: 680
  },
  dialogTitle: {
    display: 'grid',
    gridAutoFlow: 'column',
    gridTemplateColumns: '1fr max-content',
    padding: theme.spacing(3, 3, 2, 3),

    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2, 2, 1, 2)
    }
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    padding: theme.spacing(0, 3, 3),

    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(0, 2, 2, 2)
    }
  },
  titleBox: {margin: '0 auto'},
  title: {
    ...extendedTypography.h5SemiboldDesktop,

    [theme.breakpoints.down('sm')]: {
      ...extendedTypography.h5SemiboldMobile
    }
  },
  closeIcon: {
    position: 'absolute',
    top: 20,
    right: 20,

    padding: 0,
    alignSelf: 'baseline',

    '& svg': {
      width: 20,
      height: 20
    }
  }
}));

export const ModalNext = ({
  title,
  children,
  open,
  onClose,
  titleClass,
  dialogContentClassName,
  paperClassName,
  centerVertical = false,
  closeOnClickOutside = true,
  ...props
}) => {
  const classes = useStyles();

  return (
    <ThemeProvider theme={themeNext}>
      <Dialog
        open={open}
        onClose={closeOnClickOutside ? onClose : () => {}}
        classes={{
          paper: clsx(classes.paper, paperClassName),
          paperWidthXs: classes.paperWidthXs,
          paperWidthSm: classes.paperWidthSm,
          paperWidthMd: classes.paperWidthMd,
          paperWidthLg: classes.paperWidthLg,
          container: clsx(
            classes.container,
            centerVertical && classes.containerXsCentered
          ),
          paperFullWidth: classes.paperFullWidth
        }}
        fullWidth
        {...props}
      >
        <DialogTitle disableTypography className={classes.dialogTitle}>
          {typeof title === 'string' ? (
            <Typography className={clsx(classes.title, titleClass)}>
              {title}
            </Typography>
          ) : (
            <div className={classes.titleBox}>{title}</div>
          )}
          <IconButton
            size='small'
            edge='end'
            color='inherit'
            onClick={onClose}
            aria-label='close'
            classes={{root: classes.closeIcon}}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          className={clsx(classes.dialogContent, dialogContentClassName)}
        >
          {children}
        </DialogContent>
      </Dialog>
    </ThemeProvider>
  );
};
